import { LETTER } from '@/entities/label';
import { LabelEditor } from '@/widgets/label-editor';
import { useDocumentTitle } from '@/shared/lib';

// /type2-letter-sheets.html: 1, 2, 4 or 8 labels on a US Letter page with cut guides.
export function LetterPage() {
  useDocumentTitle(LETTER.title);
  return <LabelEditor spec={LETTER} />;
}
